const BackgroundDisplay = ({ title = "" }) => {
  return (
    <div className="Background-Display-Image-Container">
      <div className="Centered-Content">
        {" "}
        <h1>{title}</h1>
      </div>
    </div>
  );
};

export default BackgroundDisplay;
